module.exports = __webpack_public_path__ + "dash_20_app_assets/img/opengraph.9b6a26d3.png";